import {
  BMBadgeCornerRibbon,
  BMComponentsType,
  BMElevationType,
  BMPrimitives,
  BMText,
  useBMTheme,
} from "@traveloka/district-bloom";
import IcProductDuotoneFlightFill from "@traveloka/icon-kit-web/react/IcProductDuotoneFlightFill";
import IcProductDuotoneHotelFill from "@traveloka/icon-kit-web/react/IcProductDuotoneHotelFill";
import IcProductDuotoneTrainFill from "@traveloka/icon-kit-web/react/IcProductDuotoneTrainFill";
import IcSystemChevronRight from "@traveloka/icon-kit-web/react/IcSystemChevronRight";
import { StyleSheet, ViewStyle } from "react-native";
import LinearGradient from "react-native-linear-gradient";
import BMView from "../../../../components/View/BMView";
import { useMobileContentResource } from "../../../../core/resource/MobileResourceProvider";
import { MobileProductCardProps } from "./MobileProductCard";

type Coord = {
  x: number;
  y: number;
};

type LinearGradientProps = {
  colors: number[];
  start: Coord;
  end: Coord;
  locations: number[];
};

export function MobileProductCardContent(props: MobileProductCardProps) {
  const { productType, type, isNew, disabled } = props;

  const { CorporatePostLogin: cr } = useMobileContentResource();
  const { BMComponents, BMElevation } = useBMTheme();
  const themeStyles = createStyles(BMComponents, BMElevation);

  let UsedIcon = IcProductDuotoneFlightFill;
  let contentText = "";
  let usedStyle: LinearGradientProps | {} = {};
  const usedIconStyle: ViewStyle = {};

  switch (productType) {
    case "FLIGHT":
      UsedIcon = IcProductDuotoneFlightFill;
      contentText = cr.productFlightText;
      usedStyle = {
        colors: ["#51D1FC", "#30C5F7"],
        start: { x: 0.05, y: 0.27 },
        end: { x: 0.95, y: 0.73 },
        locations: [0.398, 1],
      };
      usedIconStyle.backgroundColor = BMPrimitives.BMBrand.productFlights;
      break;
    case "HOTEL":
      UsedIcon = IcProductDuotoneHotelFill;
      contentText = cr.productHotelText;
      usedStyle = {
        colors: ["#3171B9", "#235D9F"],
        start: { x: 0.075, y: 0.235 },
        end: { x: 0.925, y: 0.765 },
        locations: [0.4254, 1],
      };
      usedIconStyle.backgroundColor = BMPrimitives.BMBrand.productHotels;
      break;
    case "TRAIN":
      UsedIcon = IcProductDuotoneTrainFill;
      contentText = cr.productTrainText;
      usedStyle = {
        colors: ["#F7B543", "#E08E00"],
        start: { x: 0.345, y: 0.025 },
        end: { x: 0.655, y: 0.975 },
        locations: [0.489, 1],
      };
      usedIconStyle.backgroundColor = BMPrimitives.BMBrand.productTrains;
      break;
    default:
      // Handle unknown product type
      return null;
  }

  if (disabled) {
    usedStyle = {
      colors: [BMComponents.BMStyleIconInkMuted],
      start: { x: 0, y: 0 },
      end: { x: 1, y: 1 },
      locations: [0, 1],
    };
    usedIconStyle.backgroundColor = "#707577";
  }

  const isNormal = type === "NORMAL";

  return (
    <BMView flex>
      {isNew && (
        <BMView style={styles.ribbon}>
          <BMBadgeCornerRibbon
            label="New!"
            position="TOP_LEFT"
            type={disabled ? "GREY" : "GREEN"}
          />
        </BMView>
      )}
      <LinearGradient style={themeStyles.linearGradient} {...usedStyle}>
        <BMView flex spacing="xl" align="start" justify="between">
          <BMView style={[styles.icon, usedIconStyle]}>
            <UsedIcon color="#fff" accentColor="#fff" />
          </BMView>
          <BMView style={styles.textSection} row justify="between" align="end">
            <BMText
              variant={isNormal ? "uiLarge" : "uiNormal"}
              ink="BMStyleTextInkPrimaryInvert"
            >
              {contentText}
            </BMText>
            {isNormal && (
              <IcSystemChevronRight width={24} height={24} color="#fff" />
            )}
          </BMView>
        </BMView>
      </LinearGradient>
    </BMView>
  );
}

const styles = StyleSheet.create({
  flex: {
    flex: 1,
  },
  ribbon: {
    position: "absolute",
    zIndex: 1,
    top: -8,
    left: -7,
  },
  icon: {
    padding: BMPrimitives.BMSize.sm,
    borderRadius: BMPrimitives.BMRadius.rounded,
  },
  textSection: {
    width: "100%",
  },
});

function createStyles(
  BMComponents: BMComponentsType,
  BMElevation: BMElevationType
) {
  return StyleSheet.create({
    linearGradient: {
      flex: 1,
      padding: BMPrimitives.BMSize.md,
      borderRadius: BMComponents.BMStyleCardRadiusCompact,
      ...BMElevation.elevation2,
      backgroundColor: BMComponents.BMStyleCardBgcolor,
      borderColor: BMComponents.BMStyleCardBordercolor,
      borderWidth: 1,
    },
  });
}
